export const menuInit = () => {
    let $a_elem = $('#main-list > li > a.parent-link');
    $a_elem.on('click', function (e) {
        if ($(this).data('url')) {
            window.location.href = $(this).data('url');
        }
    });
};

export const adjustSubmenu = ($menuItem) => {
    var bottomOffset,
        pageHeight,
        adjustment,
        theFold,
        menutop,
        wintop,
        maxtop,
        $submenu = $menuItem.find('.submenu');

    menutop = $menuItem.offset().top;
    wintop = $(window).scrollTop();
    maxtop = menutop - wintop - 0; // max = make the top of the sub almost touch top

    bottomOffset = menutop + $submenu.height() + 1; // Bottom offset of the menu.
    pageHeight = $('body').height(); // Height of the entire page.
    adjustment = 60 + bottomOffset - pageHeight;
    theFold = $(window).height() + wintop - 0; // The fold.

    if (theFold < bottomOffset - adjustment) {
        adjustment = bottomOffset - theFold;
    }

    if (adjustment > maxtop) {
        adjustment = maxtop;
    }
    if (adjustment > 1) {
        $submenu.css('margin-top', '-' + adjustment + 'px');
    } else {
        $submenu.css('margin-top', '');
    }
};

/* Collapse Sidebar functionality */
export const sidebarInit = () => {
    let $sidebar_10_12 = $('.level-10-12');
    let $collapsed_tw_mr_3 = $('.collapsed-tw-mr-3');
    let $collapsed_tw_rounded_full_lg = $('.collapsed-tw-rounded-full-lg');

    let $elem = $('#collapse-menu');
    let $sidebar_elem = $('#sidebar-menu');
    let $collapseOnCollapsedBody = $('.collapse-on-collapsed-body');

    $elem.on('click', function (e) {
        $sidebar_elem.toggleClass('collapsed').toggleClass('tw-w-10').toggleClass('col-2');
        $sidebar_10_12.toggleClass('tw-w-10/12');
        $collapsed_tw_mr_3.toggleClass('tw-mr-3').toggleClass('tw-mx-1');
        $collapsed_tw_rounded_full_lg.toggleClass('tw-rounded-r-full').toggleClass('tw-rounded-lg').toggleClass('tw-m-1');
        $collapseOnCollapsedBody.removeClass('show');

        let d = new Date();
        d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000); /* Keep this cookie for a week */
        if (getCookie('menu_collapsed') === '' || getCookie('menu_collapsed') === 0) {
            document.cookie = 'menu_collapsed=1; expires=' + d.toUTCString() + ';path=/';
        } else {
            document.cookie = 'menu_collapsed=0; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/';
        }
    });

    let $elemE = $('#expand-menu');
    let $sidebar_elemE = $('#sidebar-menu');
    $elemE.on('click', function (e) {
        $sidebar_elemE.toggleClass('collapsed').toggleClass('tw-w-10').toggleClass('col-2');
        $sidebar_10_12.toggleClass('tw-w-10/12');
        $collapsed_tw_mr_3.toggleClass('tw-mr-3').toggleClass('tw-mx-1');
        $collapsed_tw_rounded_full_lg.toggleClass('tw-rounded-r-full').toggleClass('tw-rounded-lg').toggleClass('tw-m-1');

        let d = new Date();
        d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000); /* Keep this cookie for a week */
        if (getCookie('menu_collapsed') === '' || getCookie('menu_collapsed') === 0) {
            document.cookie = 'menu_collapsed=1; expires=' + d.toUTCString() + ';path=/';
        } else {
            document.cookie = 'menu_collapsed=0; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/';
        }
    });

    let $collapseOnCollapsedIcons = $('.collapse-on-collapsed');
    $collapseOnCollapsedIcons.on('click', function (e) {
        if (!(getCookie('menu_collapsed') === '' || getCookie('menu_collapsed') === 0)) {
            $sidebar_elemE.toggleClass('collapsed').toggleClass('tw-w-10').toggleClass('col-2');
            $sidebar_10_12.toggleClass('tw-w-10/12');
            $collapsed_tw_mr_3.toggleClass('tw-mr-3').toggleClass('tw-mx-1');
            $collapsed_tw_rounded_full_lg.toggleClass('tw-rounded-r-full').toggleClass('tw-rounded-lg').toggleClass('tw-m-1');

            document.cookie = 'menu_collapsed=0; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/';
        }
    });
};

export const getCookie = (cname) => {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
};

document.addEventListener('DOMContentLoaded', function () {
    menuInit();
    sidebarInit();
});
